import { useIsMutating } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { FC } from "react";

import { useEditOrderMutation } from "@/features/order/hooks/use-edit-order";
import { useStoreProduct } from "@/features/product/contexts/product-context";
import { ROUTES } from "@/features/store/settings/routes";

type AmendOrderButtonProps = {
  orderId: string;
  productSku: string;
  lineItemId: string;
  children: (arg: AmendOrderButtonChildrenProps) => React.ReactNode;
};

export type AmendOrderButtonChildrenProps = {
  isLoading: boolean;
  handleAmendOrderLineItem: () => void;
};

export const AmendOrderButton: FC<AmendOrderButtonProps> = ({
  orderId,
  productSku,
  lineItemId,
  children,
}) => {
  const router = useRouter();
  const { config } = useStoreProduct();
  const { mutateAsync: editOrder } = useEditOrderMutation();
  const isEditOrderMutating = useIsMutating({ mutationKey: ["ORDER_EDIT"] });

  const amendOrderLineItemCreatePreview = async () => {
    if (!config) return;

    // total qty = item qty * versions
    const versions = +(config.versions ?? 0);
    let quantity = typeof config?.quantity === "number" ? config.quantity : 1;
    if (versions) quantity *= versions;

    await editOrder({
      type: "amendLineItem",
      productSku,
      lineItemId,
      orderId,
      config,
      quantity,
    });

    router.push(`${ROUTES.ORDERS}/${orderId}`);
  };

  return children({
    isLoading: !!isEditOrderMutating,
    handleAmendOrderLineItem: amendOrderLineItemCreatePreview,
  });
};
